// tslint:disable: no-unused-expression
import { Component, Input, ViewChild, AfterViewInit, ElementRef, OnChanges, SimpleChanges } from '@angular/core';

import { PrettyTooltipService } from 'src/app/services/TemplateServices/pretty-tooltip.service';

@Component({
  templateUrl: './pretty-tooltip.component.html',
  styleUrls: ['./pretty-tooltip.component.scss'],
  selector: 'app-pretty-tooltip',
})
export class PrettyTooltipComponent implements OnChanges, AfterViewInit {

  constructor(public prettyTooltip: PrettyTooltipService) { }

  // card: Objeto referencia del tooltip
  @ViewChild("cardContent", { static: true }) card: ElementRef;

  // title: cabecera del tooltip
  @Input() title = "";
  // text: cuerpo del tooltip
  @Input() text = "";
  // direction: dirección en que se mostrará el tooltip → Opciones: 'top', 'bottom', 'left', 'right'
  @Input() direction = "bottom";

  ngOnChanges(event: SimpleChanges) {
    // ↓ Valida si se cambia la dirección del tooltip
    if (event.direction) {
      // ↓ Valida que la ventana del navegador tenga el tamaño de un móvil
      if (window.innerWidth <= 600) { this.direction = (this.direction === "left" || this.direction === "right") ? "bottom" : this.direction; }
      // ↑ Ajusta la dirección verticalmente para que no se pierdan en la versión móvil
    }
  }

  ngAfterViewInit() {
    // referencePosition: Guarda el elemento padre del tooltip
    const referencePosition: HTMLElement = this.prettyTooltip.currentTag;
    // tooltipElm: Guarda el elemento tooltip
    const tooltipElm: HTMLElement = this.card.nativeElement;
    // ↓ Obtiene las coordenadas del tooltip en la pantalla
    let { posX, posY } = this.getReferencePosition({ posX: referencePosition.offsetLeft, posY: referencePosition.offsetTop, }, referencePosition);
    // ↑ posX: Posición horizontal, posY: Posición vertical
    // ↓ Verifica si el tooltip se mostrará horizontalmente
    if (this.direction === "left" || this.direction === "right") {
      // ↓ Acomoda horizontalmente el tooltip al lado del elemento padre sin sobreponerse
      posX += this.direction === "left" ? (- 14 - tooltipElm.offsetWidth - referencePosition.offsetWidth) : 14;
      // ↓ Acomoda verticalmente el tooltip al medio del elemento padre
      posY -= (referencePosition.offsetHeight / 2) + (tooltipElm.offsetHeight / 2);
    } else {
      // ↓ Acomoda verticalmente el tooltip sobre el elemento padre sin sobreponerse
      posY += this.direction === "top" ? (- 14 - tooltipElm.offsetHeight - referencePosition.offsetHeight) : 14;
      // ↓ Acomoda horizontalmente el tooltip al medio del elemento padre
      posX -= (referencePosition.offsetWidth / 2) + (tooltipElm.offsetWidth / 2);
    }
    // ↓↓ Mueve el tooltip a las coordenadas calculadas
    tooltipElm.style.top = (posY + referencePosition.offsetHeight) + "px";
    tooltipElm.style.left = (posX + referencePosition.offsetWidth) + "px";
    // ↓ Verifica si el tooltip sobrepasa el tamaño horizontal de la página
    if ((tooltipElm.offsetLeft < 5) || (tooltipElm.offsetLeft + tooltipElm.offsetWidth) > (window.innerWidth - 5)) {
      // ↓ Modifica la apariencia del tooltip
      tooltipElm.classList.add("not-border-icon");
    }
    // ↓ Acomoda el tooltip dentro de la panttalla
    tooltipElm.offsetLeft < 5 ? tooltipElm.style.left = 5 + "px" : null;
    // ↓ Verifica si el tooltip sobrepasa el tamaño horizontal de la página
    if ((tooltipElm.offsetLeft + tooltipElm.offsetWidth) > (window.innerWidth - 5)) {
      // ↓ Acomoda el tooltip dentro de la panttalla
      tooltipElm.style.left = "inherit"; tooltipElm.style.right = 5 + "px";
    }
    // ↓ Verifica si el tooltip sobrepasa el tamaño vertical de la página
    if ((tooltipElm.offsetTop + tooltipElm.offsetHeight) > (window.innerHeight + window.scrollY - 5)) {
      // ↓ Acomoda el tooltip dentro de la panttalla
      tooltipElm.style.top = (tooltipElm.offsetTop - 28 - tooltipElm.offsetHeight - referencePosition.offsetHeight) + "px";
      // ↓ Modifica la dirección del tooltip
      (this.card.nativeElement as HTMLElement).setAttribute("direction", "top");
    }
  }

  /* getReferencePosition(): Método que devuelve las coordenadas del padre del elemento recibido
    pos: Posición actual del elemento
      posX: Posición horizontal del elemento
      posY: Posición vertical del elemento
    tag: Padre del elemento
  */
  getReferencePosition(pos: { posX: number, posY: number }, tag: HTMLElement): { posX: number, posY: number } {
    // ↓ Verifica si el elemento recibido tiene elementos padres
    if (tag.offsetParent) {
      // ↓ Verifica que el padre no sea un elemento modal
      if (!tag.offsetParent.classList.value.includes("modal")) {
        // ↓ Aumenta las coordenadas horizontales del hijo de acuerdo a las coordenadas del padre
        pos.posX += (tag.offsetParent as HTMLElement).offsetLeft - (tag.offsetParent as HTMLElement).scrollLeft;
        // ↓ Aumenta las coordenadas verticales del hijo de acuerdo a las coordenadas del padre
        pos.posY += (tag.offsetParent as HTMLElement).offsetTop - (tag.offsetParent as HTMLElement).scrollTop;
        // ↓ Verifica si el elemento padre tiene elementos padre asociados
        pos = this.getReferencePosition(pos, (tag.offsetParent as HTMLElement));
      }
    }
    // ↓ Devuelve las coordenadas del elemento recibido sumando las de los elementos padres del mismo
    return { posX: pos.posX, posY: pos.posY };
  }

}
